import type { IWalletAddress, TokenType } from 'BreetHelpers';
import { selectSavedWalletAddresses, useAppSelector } from 'BreetRedux';
import { useCallback, useMemo } from 'react';

export const useSavedWalletAddressApi = () => {
	const { data: savedWalletAddressesData, isLoading: isLoadingSavedWalletAddresses } = useAppSelector(selectSavedWalletAddresses);

	const savedWalletAddresses = useMemo(() => savedWalletAddressesData?.data ?? [], [savedWalletAddressesData?.data]);

	const isSavedWalletAddressesEmpty = savedWalletAddresses.length === 0;

	const getIsWalletAddressSaved = useCallback(
		(token?: TokenType, address?: string, walletName?: string) => {
			try {
				if (isSavedWalletAddressesEmpty) return false;

				if (!address || !token || !walletName) return false;

				return savedWalletAddresses.some(
					(walletAddress) =>
						walletAddress.address === address && walletAddress.token === token && walletAddress.label === walletName
				);
			} catch {
				console.error('isWalletAddressSaved error');
				return false;
			}
		},
		[isSavedWalletAddressesEmpty, savedWalletAddresses]
	);

	const getSavedWalletAddress = useCallback(
		(filter: Partial<IWalletAddress>) => {
			try {
				if (isSavedWalletAddressesEmpty) return undefined;

				if (Object.keys(filter).length === 0) return undefined;

				return savedWalletAddresses.find((walletAddress) =>
					Object.entries(filter).every(([key, value]) => walletAddress[key as keyof IWalletAddress] === value)
				);
			} catch {
				console.error('getSavedWalletAddressByKey error');
				return undefined;
			}
		},
		[isSavedWalletAddressesEmpty, savedWalletAddresses]
	);

	return {
		savedWalletAddresses,
		isLoadingSavedWalletAddresses,
		isSavedWalletAddressesEmpty,
		getIsWalletAddressSaved,
		getSavedWalletAddress,
	};
};
